import {
  PROVIDER_SEARCH_VERSION_BAVARIA,
  PROVIDER_SEARCH_VERSION_WESER_EMS,
} from "core/consts";
import { paletteProviderSearchBavaria } from "./bcp";
import { paletteProviderSearchWeserEms } from "./weserEms";

export const paletteProviderSearch = {
  [PROVIDER_SEARCH_VERSION_BAVARIA]: paletteProviderSearchBavaria,
  [PROVIDER_SEARCH_VERSION_WESER_EMS]: paletteProviderSearchWeserEms,
};
